module.exports = __webpack_public_path__ + "static/media/account_register.2958424b.svg";